
import {BrowserRouter, Routes, Route} from "react-router-dom"
import "./App.css";
import HomePage from "./views/HomePage";
import Header from "./views/Header"
import AboutMe from "./views/AboutMe"
import Reads from "./views/Reads"
import Resume from "./views/Resume"
import { Analytics } from "@vercel/analytics/react"

function App() {
  return (
    <div>
      <BrowserRouter>
     <Header />
      <Routes>
        <Route path="/" element={<HomePage/>} />
        <Route path="/About" element={<AboutMe/>}/>
        <Route path="/MyReads" element={<Reads/>}/>
        <Route path="/Resume" element={<Resume/>}/>
        <Route path="*" element={<h1>Error</h1>} />
      </Routes>
    </BrowserRouter>
    <Analytics/>
    </div>
    
  );
}

export default App;